/**
 * Shared hooks used across CSK stories (upstream of src/stories).
 * Add hooks here when multiple stories use the same behaviour (e.g. visibility, animation preferences).
 */
export { default as useIsVisible } from "./use-is-visible";
export {
  useA11yWarnings,
  type UseA11yWarningsResult,
} from "./use-a11y-warnings";
export { useIsDev } from "./use-is-dev";
export {
  usePageWeightWarnings,
  type PageWeightMetrics,
  type UsePageWeightWarningsOptions,
  type UsePageWeightWarningsResult,
} from "./use-page-weight-warnings";
export {
  usePerformanceWarnings,
  type PerformanceMetrics,
  type UsePerformanceWarningsResult,
} from "./use-performance-warnings";
export { useReducedMotion } from "./use-reduced-motion";
export { useArticleBlockLoop } from "./use-article-block-loop";
export { useCskPreviewMode } from "./use-csk-preview-mode";
export { useCommentsPreviewMode } from "./use-comments-preview-mode";
export { useIsTouchLikeDevice } from "./use-is-touch-like-device";
export { useShowStoryComments } from "./use-show-story-comments";
export { useCskCommentCount } from "./use-csk-comment-count";
export { useCskCommentsLinkUrl } from "./use-csk-comments-link-url";
export { useFocusTrap, type UseFocusTrapOptions } from "./use-focus-trap";
export { useCskDevLanOrigin } from "./use-csk-dev-lan-origin";
